import Vue from 'vue'
import './axios'
import './uiv'
import './ui-components'
import './vue-i18n'
import './vue-paginate'
import './wsc-shop'
import locales from './wsc-locales'
import { translatable, translatableOrDefault } from './wsc-translatable'
import _get from 'lodash/get'

function registerHelpers () {
  // register locales
  Vue.prototype.$usedLocale = locales.usedLocale
  Vue.prototype.$defaultLocale = locales.defaultLocale

  // register translatable
  Vue.prototype.$translatable = (model, prop, locale = undefined) => {
    // if no other locale is provided
    let storeLocale = locales.usedLocale
    return translatableOrDefault(model, prop, locale || storeLocale)
  }

  Vue.prototype.$translatableNoDefault = (model, prop, locale = undefined) => {
    let storeLocale = locales.usedLocale
    return translatable(model, prop, locale || storeLocale)
  }

  // register lodash get helper
  Vue.prototype.$_get = _get
}

registerHelpers()



// WEBPACK FOOTER //
// ./client/plugins/index.js